<div class="title-dropdown-nav">
  <mat-form-field>
    <mat-select
      [(value)]="currentNav"
      panelClass="title-drowpdown-nav-panel"
      disableOptionCentering
      >
      <mat-select-trigger>
        <mat-icon [class]="currentNav?.iconClass + ' title-icon'">{{
          currentNav?.icon
        }}</mat-icon>
        <span class="title">{{ currentNav?.title | translate }}</span>
        <mat-icon class="dropdown-icon">expand_more</mat-icon>
      </mat-select-trigger>
      @for (nav of navList; track nav) {
        @if (nav.customEnable !== false) {
          <ng-container *itcFeatureEnabled="nav.feature">
            <ng-container *itcModuleEnabled="nav.module">
              <mat-option
                [value]="nav"
                [routerLink]="[nav.route]"
                *itcPermissionsRequired="nav.permissions"
                >
                @if (nav.icon) {
                  <mat-icon
                    [class]="nav.iconClass + ' title-icon'"
                    >{{ nav.icon }}</mat-icon
                    >
                  }
                  <span class="title">{{ nav.title | translate }}</span>
                </mat-option>
              </ng-container>
            </ng-container>
          }
        }
    </mat-select>
  </mat-form-field>
  <nav class="mobile-title-nav-buttons" aria-label="Main navigation">
    <div class="mobile-title-nav-buttons__list">
      @for (nav of navList; track nav) {
        @if (nav.customEnable !== false) {
          <ng-container *itcFeatureEnabled="nav.feature">
            <ng-container *itcModuleEnabled="nav.module">
              <button
                mat-button
                class="primary-navigation-button"
                [routerLink]="[nav.route]"
                [class.is-active-tab]="nav.route === currentNavRoute"
                [attr.aria-current]="nav.route === currentNavRoute ? 'page' : null"
                *itcPermissionsRequired="nav.permissions"
              >
                <span class="title">{{ nav.title | translate }}</span>
              </button>
            </ng-container>
          </ng-container>
        }
      }
    </div>
  </nav>
</div>
